import { Backdrop, CircularProgress, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Route, Routes, useParams } from 'react-router-dom'

import { getSuborganizations } from '../../../redux/actions/Suborganizations'
import { InProgressPage } from '../../InProgress/InProgress'
import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'

import TableNavigable from './TableNavigable/TableNavigable'
import useStyles from './useStyles'

export default function InternalRecycleAll () {
  return (
    <Routes>
      <Route path="/" element={<InProgressPage />} />
      <Route path=":id" element={<SuborganizationsRecycleAll />} />
    </Routes>
  )
}

function SuborganizationsRecycleAll () {
  const classes = useStyles()
  const { id } = useParams()
  const dispatch = useDispatch()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [suborganization, setsuborganization] = useState(null)

  // get suborganization with id
  const handleGetSuborganization = async () => {
    const response = await dispatch(getSuborganizations(id))
    if (response) {
      setsuborganization(response)
    }
  }

  useEffect(async () => {
    setLoading(true)
    await handleGetSuborganization()
    setLoading(false)
  }, [id])

  return (
    <div className={classes.root}>
      <BreadcrumbsComponent
        name={suborganization ? suborganization.suborganizationName : ''}
      />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Papelera interna de reciclaje
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <Typography className={classes.typography}>
          Esta sección se listan los documentos eliminados definitivamente del
          estudio {suborganization && suborganization.suborganizationName}
        </Typography>
      </div>

      <div className={classes.boxTable}>
        <TableNavigable
          id={id}
          rows={rows}
          setRows={setRows}
          setLoading={setLoading}
        />
      </div>
    </div>
  )
}
